// filepath: src/app/shared/custom-paginator-intl.ts
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

export function getCustomPaginatorIntl(
  translate: TranslateService
): MatPaginatorIntl {
  const paginatorIntl = new MatPaginatorIntl();

  const setLabels = () => {
    paginatorIntl.itemsPerPageLabel = translate.instant(
      'ResultsAngularMaterial.ItemsPerPage'
    );
    paginatorIntl.nextPageLabel = translate.instant(
      'ResultsAngularMaterial.NextPage'
    );
    paginatorIntl.previousPageLabel = translate.instant(
      'ResultsAngularMaterial.PreviousPage'
    );
    paginatorIntl.firstPageLabel = translate.instant(
      'ResultsAngularMaterial.FirstPage'
    );
    paginatorIntl.lastPageLabel = translate.instant(
      'ResultsAngularMaterial.LastPage'
    );
    paginatorIntl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number
    ) => {
      if (length === 0 || pageSize === 0) {
        return `0 ${translate.instant('ResultsAngularMaterial.of')} ${length}`;
      }
      const start = page * pageSize + 1;
      const end = Math.min(length, start + pageSize - 1);
      return `${start} - ${end} ${translate.instant(
        'ResultsAngularMaterial.of'
      )} ${length}`;
    };
    paginatorIntl.changes.next();
  };

  setLabels();
  translate.onLangChange.subscribe(() => setLabels());

  return paginatorIntl;
}
